import { AxiosResponse } from 'axios'
import apiClient from 'api/common/common'
import { RewardSlipResponse } from 'api/common/responses'
import { Status } from 'api/common/statuses'

/**
 * 報酬明細取得API
 * @param targetMonth
 * @param callback
 */
export const rewardSlipAPI = async (targetMonth: string, callback: (response?: RewardSlipResponse, status?: Status) => void) => {
  await apiClient.get(`/rewardSlip/${targetMonth}`).then((response: AxiosResponse<RewardSlipResponse>) => {
    const status = response?.headers['x-aqc-status'] ?? 'failed'
    const apiResult = response?.data
    callback(apiResult, status)
  })
}
